import React from "react";

import {
  applyAvatarImageFallback,
  baseURLImage,
  formatHours,
  truncateTextReporting,
} from "Utils/utils";

const Card = ({
  singleTimesheet,
  setSelectedWorkerInSidebar,
  selectedWorker,
  setPage,
  selectedWorkerInSidebar,
  isSmallAvatart = false,
  isInactive = false,
}) => {
  const handleImageError = (e, fname, lname) => {
    applyAvatarImageFallback(e, fname, lname);
  };

  const handleClickedItem = (item) => {
    if (
      item?.id != null &&
      selectedWorkerInSidebar?.id != null &&
      String(item.id) === String(selectedWorkerInSidebar.id)
    ) {
      setSelectedWorkerInSidebar(null);
      setPage(1);
    } else {
      setSelectedWorkerInSidebar(item);
      setPage(1);
    }
  };

  const pendingCount = Number(singleTimesheet?.pending_time_sheet_count) || 0;
  const sleepoverCount = Number(singleTimesheet?.sleepover_count) || 0;
  const hasPending =
    pendingCount > 0 || singleTimesheet?.color === "yellow";
  const avatarSize = isSmallAvatart ? "h-9 w-9" : "h-9 w-9";
  const initials = `${(singleTimesheet?.first_name || "").charAt(0)}${(singleTimesheet?.last_name || "").charAt(0)}`.toUpperCase();

  let cardClasses =
    "w-full flex cursor-pointer items-center gap-2.5 rounded-xl border px-3 py-2.5 transition-colors";
  if (selectedWorker) {
    cardClasses += " border-[#4A6BB6] bg-[#EEF2FB]";
  } else if (hasPending) {
    cardClasses += " border-[#F3E0B0] bg-[#FEF4E2]";
  } else {
    cardClasses += " border-[#D4E9BE] bg-[#EDF7E1]";
  }

  return (
    <div
      className={cardClasses}
      key={singleTimesheet?.id}
      onClick={() => handleClickedItem(singleTimesheet)}
      title={
        isInactive
          ? `${singleTimesheet?.first_name} ${singleTimesheet?.last_name} (Inactive)`
          : `${singleTimesheet?.first_name} ${singleTimesheet?.last_name}`
      }
    >
      <div className={`${avatarSize} flex-shrink-0`}>
        {singleTimesheet?.photo ? (
          <img
            onError={(e) =>
              handleImageError(
                e,
                `${singleTimesheet?.first_name}`,
                `${singleTimesheet?.last_name}`
              )
            }
            className={`object-cover ${avatarSize} rounded-full`}
            src={baseURLImage(singleTimesheet?.photo)}
            alt="avatar"
          />
        ) : (
          <div
            className={`flex ${avatarSize} items-center justify-center rounded-full bg-[#EEF2FB] text-xs font-bold text-[#4A6BB6]`}
          >
            {initials}
          </div>
        )}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <label
          className={`cursor-pointer text-sm font-semibold text-[#0F172A] whitespace-nowrap ${
            isInactive ? "text-gray-400 opacity-75" : ""
          }`}
          title={isInactive ? "Inactive worker" : undefined}
        >
          {truncateTextReporting(
            `${singleTimesheet?.first_name} ${singleTimesheet?.last_name}`,
            14
          )}
        </label>
        {isInactive && (
          <span className="text-[10px] font-medium uppercase tracking-wide text-red-500">
            Inactive
          </span>
        )}
        <span
          className={`text-[11px] font-medium text-[#64748B] ${
            isInactive ? "opacity-75" : ""
          }`}
        >
          {singleTimesheet?.time_sheet_count} timesheets ·{" "}
          {formatHours(singleTimesheet?.total_hours) || "0h"}
        </span>
        {sleepoverCount > 0 && (
          <span
            className={`text-[11px] font-medium text-[#64748B] ${
              isInactive ? "opacity-75" : ""
            }`}
          >
            Sleepover: {sleepoverCount}
          </span>
        )}
      </div>
      {pendingCount > 0 && (
        <span
          className="inline-flex h-5 min-w-[20px] shrink-0 items-center justify-center rounded-full bg-[#FEF3C7] px-1.5 text-center text-[11px] font-bold tabular-nums leading-none text-[#D97706] ring-1 ring-[#D97706] pt-[3px]"
          title={`${pendingCount} pending timesheet${pendingCount === 1 ? "" : "s"} in this period`}
        >
          {pendingCount}
        </span>
      )}
    </div>
  );
};

export default Card;
